__turbopack_context__.v({
  "description": "AuthFormHeader-module-scss-module__h25WQW__description",
  "header": "AuthFormHeader-module-scss-module__h25WQW__header",
  "root": "AuthFormHeader-module-scss-module__h25WQW__root",
  "subtitle": "AuthFormHeader-module-scss-module__h25WQW__subtitle",
  "title": "AuthFormHeader-module-scss-module__h25WQW__title",
});
